import React from 'react'
import {
  UncontrolledDropdown as Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from '@/components/ui-compat'
import { useTranslation } from 'react-i18next'
import { languages } from '../constants/language.ts'

// Import all flag images using Vite's glob import
const flagImages = import.meta.glob('../assets/img/flags/*.png', { eager: true, import: 'default' })

// Create a map of language code to image URL
const getFlagUrl = (code) => {
  const key = `../assets/img/flags/${code}.png`
  return flagImages[key] || ''
}

const FlagIcon = ({ src }) => (
  <i
    style={{
      background: `transparent url(${src}) 0% 0% no-repeat padding-box`,
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      height: '16px',
      lineHeight: '16px',
      width: '24px',
      display: 'inline-block',
      marginRight: '10px',
    }}
  />
)

const LanguageSelect = () => {
  const { i18n } = useTranslation()

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
  }

  let currentLanguage = languages.find((l) => i18n.language.startsWith(l.code))

  if (currentLanguage.code !== i18n.language) changeLanguage(currentLanguage.code)

  return (
    <Dropdown>
      <DropdownToggle caret color="btn-link">
        {currentLanguage.name}
      </DropdownToggle>
      <DropdownMenu>
        {languages.map((lang) => (
          <DropdownItem
            key={lang.code}
            onClick={() => {
              changeLanguage(lang.code)
            }}
          >
            <FlagIcon src={getFlagUrl(lang.code)} />
            {lang.name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  )
}

export default LanguageSelect
